import { render, staticRenderFns } from "./CamposRequeridosBookingMsg.vue?vue&type=template&id=6ad61736&scoped=true&"
import script from "./CamposRequeridosBookingMsg.vue?vue&type=script&lang=js&"
export * from "./CamposRequeridosBookingMsg.vue?vue&type=script&lang=js&"
import style0 from "./CamposRequeridosBookingMsg.vue?vue&type=style&index=0&id=6ad61736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad61736",
  null
  
)

export default component.exports